/**
 * Regions API Service
 */

import apiClient from './axios';
import { ApiResponse } from './types';

export interface Region {
  id: number;
  name: string;
  code: string;
}

export const regionsApi = {
  /**
   * Get list of regions (Tanzania)
   */
  getRegions: async (): Promise<Region[]> => {
    const response = await apiClient.get<Region[]>('/regions');
    return response.data;
  },
};

